import { defineComponent as _defineComponent } from 'vue'
import FiltersDialog from "@/components/base/filters/FiltersDialog.vue";
import FiltersDesign from "@/components/base/filters/FiltersDesign.vue";
import { onBeforeMount, ref } from "vue";
import store from "@/store";
import { BillsFilters } from "@/services/TablePage/bills";
import { useBillsStore } from "@/store_v3/BillsStore";
import { storeToRefs } from "pinia";



export default /*#__PURE__*/_defineComponent({
  __name: 'BillsFilters',
  setup(__props) {

const isShowFilters = ref(false);
const filters = ref<BillsFilters>(null);
const { isNeedUpdateBills } = storeToRefs(useBillsStore());

onBeforeMount( () => {
    store.commit('SET_FILTERS_PARAMS_OBJECT', {});
    store.commit('SET_DEFAULT_FILTERS_PARAMS_OBJECT', {});
    filters.value = new BillsFilters();
});

const submitFilters = () => {
    isNeedUpdateBills.value = true;
    isShowFilters.value = false;
};

const clearFilters = () => {
    isNeedUpdateBills.value = true;
    filters.value.updateStartUrl();
};


return { __sfc: true,isShowFilters, filters, isNeedUpdateBills, submitFilters, clearFilters, FiltersDialog, FiltersDesign }
}

})